import { useEffect, useRef, useState } from "react";

import useTamanhoTela from "../../utils/useTamanhoTela";
import * as S from "./styles";
import podeFecharAoClicarFora from "../../utils/fecharAoClicarFora";

const GerarModalResponsivo = ({
  apenasModoPopup = false,
  ativo = false,
  blockBackgroundScroll = false,
  blocking = true,
  children,
  closeOnEscape = true,
  larguraQuebra = 1100,
  maxWidth,
  modoPopUpBannerInformativo = false,
  onAbrir = () => {},
  onFechar = () => {},
  overlayManual,
  permitirFechar = true,
  scrollLocking = false,
  style,
  tabFocus = false,
  tabIndex = 0,
  trigger,
  width,
}) => {
  const LARGURA_QUEBRA = larguraQuebra;

  const keyDownRef = useRef(null);

  const { largura } = useTamanhoTela();
  const modo = largura < LARGURA_QUEBRA ? "bottom-sheet" : "modal";

  const [aberto, setAberto] = useState(ativo);

  useEffect(() => {
    setAberto(ativo);
  }, [ativo]);

  useEffect(() => {
    if (modo !== "bottom-sheet") setAberto(false);
  }, [modo]);

  useEffect(() => {
    if (keyDownRef.current && tabFocus) {
      keyDownRef.current.addEventListener("keydown", teclaPressionada);
    }

    return () => {
      if (keyDownRef.current && tabFocus) {
        keyDownRef.current.removeEventListener("keydown", teclaPressionada);
      }
    };
  }, [keyDownRef]);

  useEffect(() => {
    if (aberto || ativo) {
      onAbrir();
      blockearBackground();
    }
    return () => {
      desbloquearBackground();
    };
  }, [aberto, ativo]);

  function blockearBackground() {
    if (blockBackgroundScroll) {
      document.body.style.overflowY = "hidden";
    }
  }

  function desbloquearBackground() {
    if (blockBackgroundScroll) {
      document.body.style.overflowY = "auto";
    }
  }

  function teclaPressionada(e) {
    if (e.key === "Enter") {
      setAberto(true);
    }
  }

  return modo === "bottom-sheet" && !apenasModoPopup ? (
    <div tabIndex={tabFocus ? tabIndex : null} ref={keyDownRef} style={style}>
      {overlayManual && aberto && <S.OverlayManual />}
      <button
        onClick={() => {
          setAberto(true);
        }}
      >
        {trigger}
      </button>
      <S.BottomSheetCustomizado
        open={aberto || ativo}
        onDismiss={() => {
          if (!podeFecharAoClicarFora(permitirFechar)) return;
          setAberto(false);
          onFechar();
          desbloquearBackground();
        }}
        onClick={() => {
          if (!aberto && !ativo) {
            onAbrir();
            blockearBackground();
          }
        }}
        blocking={blocking}
        scrollLocking={scrollLocking}
        expandOnContentDrag={false}
        draggable={false}
      >
        {children(() => {
          setAberto(false);
          onFechar();
        })}
      </S.BottomSheetCustomizado>
    </div>
  ) : (
    <div tabIndex={tabFocus ? tabIndex : null} ref={keyDownRef} style={style}>
      <S.PopupCustomizado
        closeOnEscape={closeOnEscape}
        $width={width}
        $maxWidth={maxWidth}
        trigger={trigger}
        onOpen={() => {
          onAbrir();
          blockearBackground();
        }}
        modal
        open={!!(ativo || aberto)}
        onClose={() => {
          setAberto(false);
          onFechar();
          desbloquearBackground();
        }}
        nested
        closeOnDocumentClick={podeFecharAoClicarFora(permitirFechar)}
        $modoPopUpBannerInformativo={modoPopUpBannerInformativo}
      >
        {children}
      </S.PopupCustomizado>
    </div>
  );
};

export default GerarModalResponsivo;
